import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledLine = styled(Box)(({ theme }) => ({
  width: '4px',
  backgroundColor: theme.palette.primary.main,
  margin: '16px',
  marginLeft: '13px',
  borderRadius: '5px',
}));

const StyledContainer = styled(Box)(() => ({
  display: 'flex',
  '& > section': {
    width: '100%',
  },
}));

const StyledExpanderLine = ({ children }) => (
  <StyledContainer>
    <StyledLine />
    {children}
  </StyledContainer>
);

StyledExpanderLine.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StyledExpanderLine;
